<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/xllh/zyjsrclh.png" alt="" />
            <div class="technological-process">
                <div class="rhtj">
                    <img class="top" src="./../assets/imgs/xllh/rhtj_top.png" alt="" />
                    <div class="content">
                        <div class="des">
                            非本市户籍、45周岁及以下中级职称及以上的专业技术人才，在本市同一用人单位连续缴纳社保1年以上，经单位推荐，人力资源和社会保障部门认证后入户。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/xllh/sxcl_top.png" alt="" />
                    <div class="content">
                        <div class="describe">
                            <div class="describe-item">
                                <span class="num">1</span>入户申请表;
                            </div>
                            <div style="display: flex" class="describe-item mar-t3">
                                <div class="num">2</div>
                                <div class="">
                                    人力资源和社会保障部门出具的《进入成都市人员入户联系函》;
                                </div>
                            </div>
                            <div style="display: flex" class="describe-item mar-t3">
                                <div class="num">3</div>
                                <div class="">居民户口簿和居民身份证;</div>
                            </div>
                            <div class="describe-item mar-t3">
                                <span class="num">4</span>其他材料详见“成都公安微户政”微信公众号。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bllc">
                    <img class="top" src="./../assets/imgs/xllh/bllc_top.png" alt="" />
                    <div class="content">
                        <div class="title">
                            <span class="hollow-cricle"></span> 第一步
                        </div>
                        <div class="des mar-t3">
                            <div class="require">
                                <img class="bllc11" src="./../assets/imgs/xllh/bllc11.png" alt="" />
                                填写申请表
                            </div>
                            <div class="des-item">
                                填写《成都市引进人才（职称）认证申报表》（扫描成都人才网二维码获取）；
                                <div class="cdrcwewm">
                                    <img src="./../assets/imgs/xllh/cdrcwewm_code.png" alt="" />
                                </div>
                            </div>
                            <div class="require">
                                <img class="bllc12" src="./../assets/imgs/xllh/bllc12.png" alt="" />
                                提交申请材料
                            </div>
                            <div class="describe-item">
                                持职称认证相关材料前往省人社厅、成都市及各区（市）县人才中心现场认证并办理《进入成都市人员入户联系函》（用人单位登记机关相对应同级人才中心办理或用人单位住所登记地的区（市）县人才中心办理；在蓉的部属、省属国有企事业录聘用人员，统一由四川省人力资源和社会保障厅劳动关系处办理）。
                            </div>
                        </div>
                        <div class="title mar-t3">
                            <span class="hollow-cricle"></span> 第二步
                        </div>
                        <div class="des mar-t3">
                            <div class="require">
                                <img class="bllc21" src="./../assets/imgs/xllh/bllc21.png" alt="" />
                                线上办理
                            </div>
                            <div class="des-item">
                                关注“成都公安微户政”微信公众号，在“市外户口迁入”中申请网上邮寄办理;
                            </div>
                            <div class="require">
                                <img class="bllc21" src="./../assets/imgs/xllh/bllc22.png" alt="" />
                                线下办理
                            </div>
                            <div class="describe-item">
                                本人前往入户地区（市）县公安办证中心申请入户。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/24/part-5-tittle-add.png" alt="" />
                    <div class="content">（一）成都公安微户政。全年。</div>
                    <div class="content">（二）公安办证中心。工作日和延时服务日。</div>
                </div>
                <!-- <div class="contact">
                    <img class="top" src="./../assets/imgs/xllh/zyjs-more.png" alt="" />
                    <div class="content">
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市各区（市）县公安办证中心
                        </div>
                        <span style="font-size: 13px;font-weight: 400;">（见成都公安微户政：“地图导航”栏）</span>
                    </div>
                </div> -->
                
              <div class="company-box">
                <div class="content">
                  <img class="title-img" src="./../assets/imgs/135/tel.png" alt="">
                  <div class="item-title-box">
                    <div class="item-title-company"><span>责任单位</span></div>
                    <div class="item-title-tel"><span>政策咨询电话</span></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">锦江公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-62252255">028-62252255</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">青羊公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-86647997">028-86647997</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">金牛公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-87707272">028-87707272</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">武侯公安办证中心</div>
                    <div class="item-tel"><a href="tel:96166">96166</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">高新公安办证中心</div>
                    <div class="item-tel"><a href="tel: 028-85141216"> 028-85141216</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">成华公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-83283612">028-83283612</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">天府新区办证中心</div>
                    <div class="item-tel"><a href="tel:028-85633116">028-85633116</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">青白江公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-83665063">028-83665063</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">龙泉驿公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-84882777">028-84882777</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">新都公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-83964806">028-83964806</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">温江公安办证中心</div>
                    <div class="item-tel"><a href="tel: 028-82740942"> 028-82740942</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">彭州公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-83888927">028-83888927</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">崇州公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-82180219">028-82180219</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">金堂公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-84920660">028-84920660</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">双流公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-85807202">028-85807202</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">大邑公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-88226044">028-88226044</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">蒲江公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-88551201">028-88551201</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">新津公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-82530527">028-82530527</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">邛崃公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-88740680">028-88740680</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">郫都公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-60263006">028-60263006</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">都江堰公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-61929034">028-61929034</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">简阳公安办证中心</div>
                    <div class="item-tel"><a href="tel:028-27266123">028-27266123</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">三岔 “一站式服务办证点”</div>
                    <div class="item-tel"><a href="tel:028-27066961">028-27066961</a></div>
                  </div>
                  <div class="item-box">
                    <div class="item-company">简州新城“一站式服务办证点”</div>
                    <div class="item-tel"><a href="tel:028-27031940">028-27031940</a></div>
                    <!-- <div class="item-tel"><a href="tel:028-27031941">028-27031941</a></div> -->
                  </div>
                  <div class="item-box">
                    <div class="item-company">石板凳“一站式服务办证点”</div>
                    <div class="item-tel"><a href="tel:028-27612772">028-27612772</a></div>
                  </div>
                </div>
              </div>
                <div class="sqsj" style="padding: 0.3rem;">
                    <img style="width: 100%;" src="./../assets/imgs/xllh/zyjslh_sqsj_code.png" alt="" />
                </div>
                <!-- <div class="zrdw">
            责任单位：各区（市）县公安办证中心（见成都公安微户政）
          </div> -->
                <!-- <bottom unit="各区（市）县公安办证中心（见成都公安微户政）"></bottom> -->
            </div>
        </section>
        <call phone="028-85633116" site="https://whz.cdnet110.com/cd-wx-prod/matters?modelId=510100003&eventId=510100003"></call>
    </div>
</template>

<script>
// import bottom from '../components/bottom.vue'
import call from "../components/call.vue";

export default {
    data() {
        return {};
    },

    components: {
        // bottom,
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    padding-bottom: 0.3rem;

    .top-img {
        width: 7.26rem;
        height: 4.91rem;
    }

    .technological-process {
        transform: translateY(-1.5rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.33rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                font-size: 0.26rem;
                // font-family: PingFang SC-Bold, PingFang SC;
                // font-weight: bold;
                color: #333333;
                text-align: left;
                line-height: 0.44rem;

            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.25rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .describe {
                    background: #fff;
                    border-radius: 0.2rem;
                    opacity: 1;
                    padding: 0.33rem 0.3rem 0.25rem 0.65rem;
                    box-sizing: border-box;
                    position: relative;

                    .num {
                        position: absolute;
                        left: 0.15rem;
                        min-width: 0.39rem;
                        height: 0.39rem;
                        background: #739bfe;
                        color: #ffffff;
                        display: inline-flex;
                        border-radius: 50%;
                        justify-content: center;
                        align-items: center;
                        margin-right: 0.14rem;
                    }
                }
            }
        }

        .bllc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    line-height: 0.44rem;

                    .require {
                        font-size: 0.34rem;
                        font-weight: bold;
                        color: #3d5aa3;
                        position: relative;
                        padding-left: 0.58rem;

                        .bllc11 {
                            width: 4.22rem;
                            height: 0.49rem;
                            position: absolute;
                            left: 0;
                        }

                        .bllc12 {
                            width: 3.31rem;
                            height: 0.49rem;
                            position: absolute;
                            left: 0;
                        }

                        .bllc21 {
                            width: 2.56rem;
                            height: 0.49rem;
                            position: absolute;
                            left: 0;
                        }
                    }

                    .des-item {
                        font-size: 0.25rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        margin-left: 0.2rem;
                        border-left: 0.02rem dashed #739bfe;
                        padding-bottom: 0.55rem;
                        line-height: 0.44rem;


                        .cdrcwewm {
                            width: 5.51rem;
                            height: 1.43rem;
                            margin-top: 0.16rem;
                            background-image: url("./../assets/imgs/xllh/cdrcwewm.png");
                            background-size: 100% 100%;
                            background-repeat: no-repeat;

                            img {
                                width: 1.43rem;
                                height: 1.43rem;
                            }
                        }
                    }

                    .describe-item {
                        font-size: 0.25rem;
                        font-weight: 500;
                        color: #4e4e4e;
                        padding-left: 0.33rem;
                        padding-top: 0.22rem;
                        box-sizing: border-box;
                        margin-left: 0.2rem;
                        word-break: break-all;
                        //font-family:: PingFang SC-Medium, PingFang SC;
                    }
                }
            }
        }

        .sqsj {
            width: 6.85rem;
            height: 2.61rem;
            background: #ffffff;
            border-radius: 0.26rem 0.26rem 0.26rem 0.26rem;
            margin: 0.3rem auto 0;
            padding-top: 0.3rem;
            box-sizing: border-box;

            .zyjslh-sqsj {
                width: 5.58rem;
                height: 1.94rem;
                background-image: url("./../assets/imgs/xllh/zyjslh_sqsj.png");
                background-size: 100% 100%;
                margin: 0 auto;
                text-align: left;

                img {
                    width: 1.94rem;
                    height: 1.94rem;
                }
            }
        }

        .zrdw {
            font-size: 0.24rem;
            font-weight: 500;
            color: #97a9d9;
            margin-top: 0.16rem;
        }
        
      .company-box {
        margin-top: 0.2rem;
        padding: 0 0.33rem;
        color: #4E4E4E;
        .content {
          width: 6.86rem;
          box-sizing: border-box;
          background-color: #fff;
          border-radius: 0.2rem;
          margin: 0 auto;
          margin-top: 0.22rem;
          padding: 0 0.2rem;
          padding-bottom: 0.55rem;
          .title-img {
            width: 5.31rem;
            height: 1.33rem;
            margin-top: 0.24rem;
          }
          .item-title-box {
            width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 0.3rem;
            .item-title-company {
              width: 3.95rem;
              display: flex;
              justify-content: center;
              span {
                display: inline-block;
                width: 1.37rem;
                height: 0.43rem;
                text-align: center;
                line-height: 0.43rem;
                color: #fff;
                background-color: #6DA8FF;
                font-size: 0.29rem;
              }
            }
            .item-title-tel {
              width: 2.5rem;
              display: flex;
              justify-content: center;
              span {
                display: inline-block;
                width: 2.21rem;
                height: 0.43rem;
                text-align: center;
                line-height: 0.43rem;
                color: #fff;
                background-color: #6DA8FF;
                font-size: 0.29rem;
              }
            }
          }
          .item-box {
            display: flex;
            align-items: center;
            border-top: 1px solid #CBC8C8;
            font-size: 0.26rem;
            height: 0.55rem;
            font-weight: bold;
            .item-company {
              width: 3.95rem;
              height: 100%;
              padding-left: 0.22rem;
              text-align: left;
              line-height: 0.55rem;
              border-right: 1px solid #CBC8C8;
            }
            .item-tel {
              width: 2.5rem;
              height: 100%;
              text-align: left;
              line-height: 0.55rem;
              padding-left: 0.22rem;
            }
          }
          .item-box:last-child {
            border-bottom: 1px solid #CBC8C8;
          }
        }
      }
    }
}
</style>
